import * as React from "react";
import { NavLink } from "react-router-dom";
import { MUIDataTableMeta } from "mui-datatables";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import { Trad } from "../../../components";
import * as Dati from "../../../Dati";
import { _ContactInfo } from "..";

export const GetClientsListColumns = () => [
    {
        name: "ID_Anag",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Cognome",
        label: Trad.Trad("Nome"),
        options: {
            filter: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiAnag(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return `${rowData.RagioneSociale || ""} ${rowData.Cognome || ""} ${rowData.Nome || ""}`;
            }
        }
    },
    {
        name: "PartitaIVA",
        label: Trad.Trad("PIVACF"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiAnag(), ...tableMeta.tableData[tableMeta.rowIndex] };
                const fiscalCode = rowData.CodiceFiscale || "";

                return (val && fiscalCode && `${val}/${fiscalCode}`) || val || fiscalCode;
            }
        }
    },
    {
        name: "TipoAnagStato",
        label: Trad.Trad("Stato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "TipoAnag",
        label: Trad.Trad("Tipo"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "RecapitiJSON",
        label: Trad.Trad("Recapiti"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiAnag(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return <_ContactInfo DetailsJSON={val} AddressesJSON={rowData.IndirizziJSON} />;
            }
        }
    },
    {
        name: "ID_Anag",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => (
                <NavLink to={`/anagrafica/${val}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </NavLink>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/ClientsList/ClientsListColumns.tsx